import { createFileRoute, Navigate } from '@tanstack/react-router';

import {
  LandingAlerts,
  LandingBeta,
  LandingCompetitorSets,
  LandingFeatures,
  LandingFooter,
  LandingHeader,
  LandingHero,
  LandingHowItWorks,
  LandingPricingStrategies,
} from '../components/landing';
import { useUser } from '../hooks/use-auth';
import { pickInitialOrg } from '../stores/org-store';

export const Route = createFileRoute('/')({
  component: HomeComponent,
});

function HomeComponent() {
  const { isLoading, isAuthenticated, user } = useUser();

  if (isAuthenticated && user) {
    const orgs = (user.organizations ?? []).map((o) => ({
      pid: o.id,
      name: o.name,
      slug: o.slug,
      setupCompletedAt: o.setupCompletedAt,
    }));
    const org = pickInitialOrg(orgs);
    if (org) {
      return <Navigate to="/$orgPid/dashboard" params={{ orgPid: org.pid }} />;
    }
  }

  return (
    <div className="min-h-screen bg-background">
      <LandingHeader />
      <main>
        <LandingHero isLoading={isLoading} />
        <LandingCompetitorSets />
        <LandingAlerts />
        <LandingPricingStrategies />
        <LandingFeatures />
        <LandingHowItWorks />
        <LandingBeta />
      </main>
      <LandingFooter />
    </div>
  );
}
